import { render } from "./PivotSettings.vue?vue&type=template&id=24aedceb&ts=true"
import script from "./PivotSettings.vue?vue&type=script&lang=ts"
export * from "./PivotSettings.vue?vue&type=script&lang=ts"

import "./PivotSettings.vue?vue&type=style&index=0&id=24aedceb&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__